import { render, staticRenderFns } from "./chainEnterpriseDetail.vue?vue&type=template&id=ec35e050&"
import script from "./chainEnterpriseDetail.vue?vue&type=script&lang=js&"
export * from "./chainEnterpriseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports